function Logo(): JSX.Element {
	return <img src='/logo.svg' alt='Enix Logo' style={{ height: 200 }} />;
}

export default Logo;
